import React from 'react'
import "./ContactForm.css"

export default function ContactForm() {
  return (
    <div id="email" className='form-wrapper'>
        <h3>Email me:</h3>
        <form id="fs-frm" name="simple-contact-form" accept-charset="utf-8" action="https://formspree.io/f/moqzvegn" method="post">
            <p>Let's Schedule a 15 min meeting and talk!</p>
            <input type="text" name="name" id="full-name" placeholder="Oussama Elabdioui" maxlength="30" required/>
            <input type="email" name="_replyto" id="email-address" placeholder="email@domain.tld" required/><br/>
            <textarea rows="5" name="message" id="message" maxlength="500" placeholder="Write your message here"></textarea>
            <input type="hidden" name="_subject" id="email-subject" value="Contact Form Submission"/>
            <input type="submit" id="submit" value="Get It Touch"/>
        </form>
    </div>
  )
}
